import React, { useState } from 'react';

import VouchersList from './VouchersList';

function VouchersPage() {
    const [loading, setLoading] = useState(true);
    const url = '/crea/api/vouchers';
    const title = 'All vouchers';

    return (
        <div>
            <VouchersList
                url={url}
                cardTitle={title}
                loading={loading}
                setLoading={setLoading}
            />
        </div>
    );
}

export default VouchersPage;
